import { useMemo } from 'react';
import { useLocation } from 'react-router';
import useGetProjects from '../../screens/ProjectListScreen/context/hooks/useGetProjects';
import DropDown from '../Dropdown';
import { ProjectsDropdownContainer } from './styles';

function ProjectsDropdown({ projectId, setDataFunc, isOptional, setProjectAccess }) {
  const { projects, isLoading } = useGetProjects();
  const errorMsg = 'No additional projects could be loaded!';
  let location = useLocation();

  const projectsToShow = useMemo(
    () =>
      !projects
        ? []
        : projects.map((project) => ({
            value: project.id,
            label: `${project.number} - ${project.name}`,
          })),
    [projects]
  );

  const onChange = (option) => {
    setDataFunc({
      project: option.label,
      projectId: option.value,
    });
  };

  return (
    <ProjectsDropdownContainer>
      <DropDown
        isLoading={isLoading}
        options={projectsToShow}
        value={projectId}
        isOptional={isOptional}
        onChange={onChange}
        placeholder='Select Project'
      />
    </ProjectsDropdownContainer>
  );
}

export default ProjectsDropdown;
